module.exports = __webpack_public_path__ + "static/media/clear_circle.8117566e.svg";